import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";

/**
 * @deprecated use @faire/web--source/common/globals/getWindow
 */
export const getWindow = (): Window & typeof globalThis => getWindowOrThrow();
